module.exports = [{"name":"English","code":"en","is_default":1},{"name":"Thai","code":"th","is_default":0},{"name":"Laos","code":"la","is_default":0},{"name":"Chinese","code":"cn","is_default":0}]


//////////////////
// WEBPACK FOOTER
// ./src/plugins/static/language.json
// module id = kwNK
// module chunks = 134